import {ChangeDetectorRef, Component, ElementRef, forwardRef, Input, OnInit} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {DashboardApiService} from '../../../../../../projects/api/src/dashboard/dashboard-api.service';
import {LoaderState} from '../../../components/loading-indicator/loader.enum';
import {tap} from 'rxjs/operators';
import {BehaviorSubject} from 'rxjs';
import {Dashboard} from '../../../../../../projects/api/src/dashboard/dashboard.model';

@Component({
    selector: 'app-dashboard-select',
    templateUrl: './dashboard-select.component.html',
    styleUrls: ['./dashboard-select.component.scss'],
    // changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => DashboardSelectComponent),
        }
    ],
    standalone: false
})
export class DashboardSelectComponent implements ControlValueAccessor, OnInit {
  public disabled = false;
  @Input() required = false;
// @Input() errorMessage = false;
//   public value: number;
  public dashboards: Dashboard[] = [];
  public dashboard: Dashboard;
  public id: number;
  public panelWidth = 0;
  public state$: BehaviorSubject<LoaderState> = new BehaviorSubject(LoaderState.inactive);
  public loaderState = LoaderState;

  constructor(private dashboardApi: DashboardApiService,
              private cd: ChangeDetectorRef,
              private hostElement: ElementRef<HTMLElement>) {
  }


  ngOnInit(): void {
    this.state$.next(LoaderState.loading);
    this.dashboardApi.getAll()
      .pipe(
        tap(() => this.state$.next(LoaderState.inactive), () => this.state$.next(LoaderState.error))
      )
      .subscribe(dashboards => {
        this.dashboards = dashboards.filter(dash => !dash.hidden || dash.id === this.id);
        this.dashboard = this.dashboards.find(dash => dash.id === this.id);
      });
  }

  public onTouched() {
  }

  public changeSelected(id: number) {
    this.id = id;
    this.dashboard = this.dashboards.find(dash => dash.id === id);
    this.onChange(id);
  }

  public updatePanelWidth(): void {
    this.panelWidth = this.hostElement.nativeElement.getBoundingClientRect().width;
    this.cd.detectChanges();
  }

  writeValue(id: number): void {
    this.id = id;
    this.dashboard = this.dashboards.find(dash => dash.id === id);
  }

  public onChange(value: number) {
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }


}
